import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type DescriptionProps = IconComponentBaseProps;

export const Description = ({
  className,
  width = 20,
  height = 20,
  fill = defaultTheme.mantineColors.gray[8],
}: DescriptionProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_5030_1879"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="21"
      >
        <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5030_1879)">
        <path
          d="M7.5 15.2916H12.5C12.6774 15.2916 12.8258 15.2317 12.9454 15.112C13.0651 14.9924 13.125 14.8439 13.125 14.6666C13.125 14.4892 13.0651 14.3408 12.9454 14.2212C12.8258 14.1014 12.6774 14.0416 12.5 14.0416H7.5C7.32264 14.0416 7.17417 14.1014 7.05458 14.2212C6.93486 14.3408 6.875 14.4892 6.875 14.6666C6.875 14.8439 6.93486 14.9924 7.05458 15.112C7.17417 15.2317 7.32264 15.2916 7.5 15.2916ZM7.5 11.9583H12.5C12.6774 11.9583 12.8258 11.8984 12.9454 11.7787C13.0651 11.6591 13.125 11.5106 13.125 11.3333C13.125 11.1559 13.0651 11.0074 12.9454 10.8878C12.8258 10.7681 12.6774 10.7083 12.5 10.7083H7.5C7.32264 10.7083 7.17417 10.7681 7.05458 10.8878C6.93486 11.0074 6.875 11.1559 6.875 11.3333C6.875 11.5106 6.93486 11.6591 7.05458 11.7787C7.17417 11.8984 7.32264 11.9583 7.5 11.9583ZM5.25646 18.4166C4.83549 18.4166 4.47917 18.2708 4.1875 17.9791C3.89583 17.6874 3.75 17.3311 3.75 16.9101V4.08971C3.75 3.66874 3.89583 3.31242 4.1875 3.02075C4.47917 2.72909 4.83549 2.58325 5.25646 2.58325H11.2517C11.4525 2.58325 11.6456 2.62228 11.831 2.70034C12.0163 2.77825 12.1774 2.88561 12.3142 3.02242L15.8108 6.51908C15.9476 6.65589 16.055 6.81693 16.1329 7.00221C16.211 7.18763 16.25 7.38075 16.25 7.58158V16.9101C16.25 17.3311 16.1042 17.6874 15.8125 17.9791C15.5208 18.2708 15.1645 18.4166 14.7435 18.4166H5.25646ZM11.25 6.82992V3.83325H5.25646C5.19229 3.83325 5.13354 3.85999 5.08021 3.91346C5.02674 3.96679 5 4.02554 5 4.08971V16.9101C5 16.9743 5.02674 17.033 5.08021 17.0864C5.13354 17.1398 5.19229 17.1666 5.25646 17.1666H14.7435C14.8077 17.1666 14.8665 17.1398 14.9198 17.0864C14.9733 17.033 15 16.9743 15 16.9101V7.58325H12.0033C11.7885 7.58325 11.6092 7.51138 11.4656 7.36763C11.3219 7.22402 11.25 7.04478 11.25 6.82992Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
